import numeral from "numeral";

function money(n, d = 2) {
  return d === 2 ? numeral(n).format("0,0.00") : numeral(n).format("0,0.000");
}

// The news site lives on its own subdomain (apps/news in this repo).
const NEWS_URL = process.env.REACT_APP_NEWS_URL || "https://news.tapngogh.com";

export { money, NEWS_URL };